import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { BulkPauseUnpauseState } from './types';

const initialState: BulkPauseUnpauseState = {
  action: 'pause',
  customerGroupId: null,
  customerId: null,
  days: 1,
  hours: 0,
  ids: [],
  names: [],
  pauseOption: 'pauseFor',
  reason: '',
};

const slice = createSlice({
  initialState,
  name: 'bulkPauseUnpause',
  reducers: {
    setAction: (state, action) => {
      state.action = action.payload;
    },
    setContext: (
      state,
      action: PayloadAction<{
        customer_group_id: null | number;
        customer_id: number;
      }>,
    ) => {
      state.customerGroupId = action.payload.customer_group_id;
      state.customerId = action.payload.customer_id;
    },
    setDays: (state, action) => {
      state.days = action.payload;
    },
    setHours: (state, action) => {
      state.hours = action.payload;
    },
    setIds: (state, action) => {
      state.ids = action.payload;
    },
    setNames: (state, action) => {
      state.names = action.payload;
    },
    setPauseOption: (state, action) => {
      state.pauseOption = action.payload;
    },
    setReason: (state, action) => {
      state.reason = action.payload;
    },
  },
});

const bulkPauseUnpause = {
  reducer: slice.reducer,
  setAction: slice.actions.setAction,
  setContext: slice.actions.setContext,
  setDays: slice.actions.setDays,
  setHours: slice.actions.setHours,
  setIds: slice.actions.setIds,
  setNames: slice.actions.setNames,
  setPauseOption: slice.actions.setPauseOption,
  setReason: slice.actions.setReason,
};

export default bulkPauseUnpause;
